var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dataBoardBox',{attrs:{"title":"各产品销售金额分布总览"}},[_c('div',{staticClass:"mr-20",attrs:{"slot":"rightTopBox"},slot:"rightTopBox"}),_c('div',{ref:"productSaleRange",staticStyle:{"height":"400px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }